import { Component } from '@angular/core';
import { Router } from '@angular/router';

/**
 *  IKTATGATÓ burok. A bal oldali menü csoportosítva viszi az oldalakat, a fejléc
 *  csak azt mutatja, hol vagyunk – felső szegmens-sáv nincs, mert a bal menüvel
 *  redundáns lenne (a CAESAR-nál is ez vált be).
 */
@Component({
  selector: 'app-iktatgato-layout',
  templateUrl: './iktatgato-layout.component.html',
  styleUrls: ['./iktatgato-layout.component.scss'],
})
export class IktatgatoLayoutComponent {
  constructor(public router: Router) {}

  private static readonly CIMEK: Record<string, string> = {
    attekintes: 'Áttekintés',
    erkeztetes: 'Érkeztetés',
    iktatas: 'Iktatás',
    ugyiratok: 'Ügyiratok',
    ugyirat: 'Ügyirat',
    irat: 'Irat',
    sulinform: 'Iktatás a Sulinformból',
    kereses: 'Keresés',
    riport: 'Statisztika',
    partnerek: 'Partnerek',
    feladatok: 'Feladatok',
    peldanyok: 'Példányok és átadás',
    kuldes: 'Tömeges kiküldés',
    bksz: 'BKSZ – kézbesítési szolgáltatás',
    kuldemenyek: 'Beérkezett küldemények és igazolások',
    kezbesites: 'Kézbesítési napló',
    irattar: 'Irattár',
    postakonyv: 'Postakönyv',
    konyvek: 'Iktatókönyvek',
    beallitasok: 'Szabályok és jogosultság',
  };

  get oldalCim(): string {
    const resz = (this.router.url.split('?')[0].split('/')[2] || 'attekintes');
    return IktatgatoLayoutComponent.CIMEK[resz] || 'Iktatgató';
  }
}
